export default __webpack_public_path__ + "static/media/yoga-pose-estimation-removebg.62ad9921.png";